import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: themes.light.brand_blue[7],
  },
  innerContainer: {
    paddingVertical: 12,
  },
  optionCard: {
    flexDirection: 'row',
    backgroundColor: themes.light.white[1],
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: themes.light.teal[6],
    position: 'relative',
  },
  optionIcon: {
    width: 40,
    height: 40,
    marginRight: 12,
  },
  title: {
    width: '90%',
  },
  description: {
    color: themes.light.gray_blue[3],
    width: '90%',
  },
  arrowIcon: {
    width: 24,
    height: 24,
    position: 'absolute',
    top: 16, // match your card padding
    right: 16, // match your card padding
    tintColor: themes.light.black[1],
  },
  optionTextContainer: {
    flex: 1,
  },
});
